import { useMemo } from 'react';
import { featureFlags } from '@shared-services/feature-flags';
import { CalEventData } from '../types';

const useIsDefaultStaffMember = (
    calEventData: CalEventData | null,
    clientId: string
) => {
    return useMemo(() => {
        // Unfortunately, we don't have a way to get the default staff member mail,
        // so we are checking if the first host username is the default staff member by checking if it matches the cal username.
        const firstHost = calEventData?.subsetOfHosts?.[0];
        const isDryRunForDefaultStaffMemberEnabled = featureFlags.getBoolean(
            'runtime.ssr.booking.dryrun.for.default.staffmember'
        );
        if (!isDryRunForDefaultStaffMemberEnabled || !firstHost) {
            return false;
        }

        const firstHostUsername = firstHost.user.username;
        const isDefaultStaffMember =
            firstHostUsername === `staffmember1-${clientId}-example-com`;

        return isDefaultStaffMember;
    }, [calEventData, clientId]);
};

export default useIsDefaultStaffMember;
